import { createContext } from 'react';
import type { GuideTourId } from '../content/tours';

/**
 * Deliberately just `start` and `stop`: navigating a running tour is the
 * provider's own business. GuideLauncher only launches one, and
 * useAutoStartTour launches its screen's tour and ends it when the screen goes
 * away. Keeping the value to stable functions also means it never changes
 * identity, so advancing a tour does not re-render every screen that calls
 * useAutoStartTour.
 *
 * Lives apart from GuideProvider so that file only exports components, which
 * is what keeps Fast Refresh working for the provider.
 */
export interface GuideContextValue {
  start: (tourId: GuideTourId) => void;
  /** Ends `tourId`, unseen, if it is running or about to. */
  stop: (tourId: GuideTourId) => void;
}

export const GuideContext = createContext<GuideContextValue | null>(null);
